const site = typeof window === 'undefined' ? 'create.lureo.com' : window.location.host;

export const desktopOnlyCopy = {
  heading: 'Scenes are made on a laptop or desktop',
  site,
  open: 'On your computer, open',
  signIn: 'Sign in',
} as const;
